import { render, staticRenderFns } from "./DataInputColor.vue?vue&type=template&id=4518cbd4&scoped=true&"
import script from "./DataInputColor.vue?vue&type=script&lang=js&"
export * from "./DataInputColor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4518cbd4",
  null
  
)

export default component.exports